module.exports = __webpack_public_path__ + "static/media/butter_scotch.f53a7d61.png";